
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// window.$ = window.jQuery = require('jquery');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + window.Laravel.apiToken,
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

window.axios.interceptors.request.use((config) => {
    if (config.url.indexOf('api.vimeo.com') > -1) {
        delete config.headers.common;
    }

    return config;
});

require('./vendor/redactor.js');
require('./vendor/redactor-plugins/alignment.js');
// require('./vendor/redactor-plugins/variable.js');
require('./vendor/redactor-plugins/custom-variables.js');
require('./vendor/redactor-plugins/video.js');


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
